import { Component, OnInit } from '@angular/core';
import { faKey, faHome, faPaperPlane, faSearch, faBell, faSignOutAlt,
  faTachometerAlt, faBuilding, faScaleBalanced, faGavel, faFileInvoiceDollar, faComments } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../_services';
import { AuthResponse } from '../_models/responses';
import { Role } from '../_models/role';
import { PremiseAssociation } from '../_models/premise_association';
import { PremiseService } from '../_services/premise.service';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  faBell = faBell;
  faSignOutAlt = faSignOutAlt;
  faKey = faKey;
  faSearch = faSearch;
  faGavel = faGavel;
  faScaleBalanced = faScaleBalanced;
  faTachometerAlt = faTachometerAlt;
  faBuilding = faBuilding;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faComments = faComments;

  currentUser!: AuthResponse | null;
  premiseAssociations!: PremiseAssociation[];

  constructor(private authenticationService: AuthenticationService,
    private premiseService: PremiseService,
    private toastr: ToastrService,
    private router: Router) { }

  ngOnInit(): void {
   this.currentUser = this.authenticationService.currentUserValue;
   console.log('Current user object::::', this.currentUser);
   const isMessageOnlyResponse =
      this.currentUser &&
      typeof this.currentUser === 'object' &&
      Object.keys(this.currentUser).length === 1 &&
      'message' in this.currentUser &&
      typeof this.currentUser.message === 'string' &&
      this.currentUser.message.trim().length > 0;

    if (isMessageOnlyResponse) {
      this.router.navigate(['/login']);
    }

  }

  logout(): void {
    this.authenticationService.logout()
  }

  openChangePassword(): void {
    this.router.navigate(['/change-password']);
  }

  openNotices(): void {
    const roles = this.currentUser?.role ?? [];
    const canManageNotices = roles.includes(Role.ROLE_ADMIN) || roles.includes(Role.ROLE_SUPER);

    this.router.navigate([canManageNotices ? '/manage-notices' : '/notices']);
  }

  isAdmin() {
    //return this.currentUser;
    if (this.currentUser) {
        if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
            return this.currentUser.role.includes(Role.ROLE_ADMIN);
        }
        else {
          return false;
        }

    }
    return false;
  }

  isUser() {
    //return this.currentUser;
    if (this.currentUser) {
        if (this.currentUser.access_token != undefined && this.currentUser.role != undefined) {
            return this.currentUser.role.includes(Role.ROLE_USER);
        }
        else {
          return false;
        }

    }
    return false;
  }


}
